import { render, staticRenderFns } from "./DashboardProjects.vue?vue&type=template&id=8fb04cf2"
import script from "./DashboardProjects.vue?vue&type=script&lang=ts"
export * from "./DashboardProjects.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fb04cf2')) {
      api.createRecord('8fb04cf2', component.options)
    } else {
      api.reload('8fb04cf2', component.options)
    }
    module.hot.accept("./DashboardProjects.vue?vue&type=template&id=8fb04cf2", function () {
      api.rerender('8fb04cf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/cards/DashboardProjects.vue"
export default component.exports